import React, { Component } from 'react';

import API from './API';

import Button from './Button';
import TinySpinner from './TinySpinner';

import ImageUserPlaceholder from './static/img/user-placeholder.jpg';
import ImageBookTrainer from './static/img/trainer-icon.png';
import ImageBookShootaway from './static/img/shoot-away-icon.png';
import ImageBookElementary from './static/img/elementary-sessions-icon.png';

class SessionListItem extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isResourceLoading: false,
            resources: this.props.resources ?? null
        }
    }

    componentDidMount() {

    }

    handleOnSelect(key) {
        if(this.props.onSelect && !this.state.isResourceLoading) {
            let o = {
                ...this.state.resources[key]
            }
            this.props.onSelect(o);
        }
    }

    handleOnSelectMultiresource() {
        // TODO: Patch
        if(this.props.title == 'Book Hoop') {
            this.props.onSelect(this.state.resources[0]['id']);
            return;
        }
        if(this.props.title == 'Elementary Session') {
            this.props.onSelect('');
            return;
        }

        if(this.props.onSelectMultiresource && !this.state.isResourceLoading) {
            let o = {
                ...this.state.resources
            }
            this.props.onSelectMultiresource(o);
        }
    }

    renderMultipleResources() {
        if(this.state.resources && Object.keys(this.state.resources).length > 0) {
            if(Object.keys(this.state.resources).length != 1) {
                let c = [];
                for(var [key, r] of Object.entries(this.state.resources)) {
                    const cKey = key;
                    c.push(
                        <div className="hw-widget__session-list__resource" onClick={() => this.handleOnSelect(cKey)}>
                            <div className="hw-widget__session-list__icon" style={{backgroundImage: `url(${r.image})`}}></div>
                            <p>{r.name}</p>
                        </div>
                    )
                }
                return c;
            }
        }
    }

    renderSingleResources() {
        // TODO: Patch
        if(this.props.title == 'Book Trainer') {
            return (
                <p className="subtitle">Train Like A Pro</p>
            )
        }

        if(this.state.resources && Object.keys(this.state.resources).length > 0) {
            if(Object.keys(this.state.resources).length == 1) {
                return (
                    <p className="subtitle">{this.state.isResourceLoading ? <TinySpinner/> : this.state.resources[Object.keys(this.state.resources)[0]].name}</p>
                )
            }
        }
    }

    render() { 
        if(this.state.isResourceLoading) {
            return (
                <div className="hw-widget__session-list__item">
                    <div className="hw-widget__session-list__face">
                        <div className="hw-widget__session-list__icon" style={{backgroundImage: `url(${this.state.resourceImage})`}}></div>
                        <div className="hw-widget__session-list__details">
                            <p className="title">{this.props.title}</p>
                        </div>
                        <div className="hw-widget__session-list__actions">
                            <TinySpinner/>
                        </div>
                    </div>
                </div>
            )
        } else {
            let bgImage = null;
            
            if(this.state.resources && Object.keys(this.state.resources).length == 1) {
                let r = this.state.resources[Object.keys(this.state.resources)[0]];
                bgImage = this.props.title == 'Book Trainer' || this.props.title == 'Elementary Session' ? ImageBookElementary : this.props.title == 'Book Hoop' ? ImageBookShootaway : r.image;
                
                return (
                    <div className="hw-widget__session-list__item" onClick={() => this.handleOnSelect(Object.keys(this.state.resources)[0])}>
                        <div className="hw-widget__session-list__face">
                            <div className="hw-widget__session-list__icon" style={{backgroundImage: `url(${bgImage})`}}></div>
                            <div className="hw-widget__session-list__details">
                                <p className="title">{this.props.title}</p>
                                {this.renderSingleResources()}
                            </div>
                        </div>
                    </div>
                );
            } else {

                bgImage = this.props.title == 'Book Trainer' ? ImageBookTrainer : this.props.title == 'Elementary Session' ? ImageBookElementary : this.props.title == 'Book Hoop' ? ImageBookShootaway : '';
                return (
                    <div className="hw-widget__session-list__item" onClick={() => this.handleOnSelectMultiresource(this.state.resources)}>
                        <div className="hw-widget__session-list__face">
                            <div className="hw-widget__session-list__icon" style={{backgroundImage: `url(${bgImage})`}}></div>
                            <div className="hw-widget__session-list__details">
                                <p className="title">{this.props.title}</p>
                                {this.renderSingleResources()}
                            </div>
                        </div>
                    </div>
                );
            }

        }
    }
}
 
export default SessionListItem;